import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Tooltip } from '../../Tooltip';
import { InfoButtonWithDropdown } from '../InfoButton';
import { useCombineCallbacks, useInput } from '../../hooks';
import { EMPTY_PROPS } from '../../helpers/types';
const InfoDropdownWithArrow = /*#__PURE__*/React.forwardRef(({
  open: openProp = false,
  defaultOpen = false,
  disabled = false,
  inverse = false,
  inverseTooltip = false,
  inverseButton = false,
  blurred = false,
  menu,
  tooltipPosition = 'bottom-start',
  tooltipAppearType = 'slide',
  tooltipTrigger = 'click',
  tooltipCloseDelay,
  tooltipProps = EMPTY_PROPS,
  buttonLabel = 'Toggle',
  buttonProps = EMPTY_PROPS,
  onToggle,
  children,
  ...props
}, forwardedRef) => {
  const [open, setOpen] = useInput(openProp, defaultOpen, onToggle);
  // @ts-expect-error Callback taken from tooltip type
  const handleToggle = useCombineCallbacks(setOpen, props?.onToggle, tooltipProps?.onToggle);
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    trigger: tooltipTrigger,
    appearType: tooltipAppearType,
    closeDelay: tooltipCloseDelay,
    position: tooltipPosition,
    disabled: disabled,
    inverse: inverse || inverseTooltip,
    blurred: blurred,
    flex: true,
    noPadding: true,
    multiline: true,
    content: menu
  }, tooltipProps, props, {
    open: open,
    onToggle: handleToggle
  }), /*#__PURE__*/React.createElement(InfoButtonWithDropdown, _extends({
    ref: forwardedRef,
    role: "button",
    "aria-label": buttonLabel,
    noFocus: true,
    disabled: disabled,
    inverse: inverse || inverseButton,
    rotated: open
  }, buttonProps), children));
});
export default InfoDropdownWithArrow;